/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Department_Fallback_TitleInputs */

const en_department_fallback_title = /** @type {(inputs: Department_Fallback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Department`)
};

const nl_department_fallback_title = /** @type {(inputs: Department_Fallback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afdeling`)
};

/**
* | output |
* | --- |
* | "Department" |
*
* @param {Department_Fallback_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const department_fallback_title = /** @type {((inputs?: Department_Fallback_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Department_Fallback_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_department_fallback_title(inputs)
	return en_department_fallback_title(inputs)
});